export default "__VITE_ASSET__BpdNbw4s__"